import { INITIAL_PERMISSIONS_ROLES, USER_ROLES } from '../constants';
import { PermissionByEntityType } from '../models';

export const FOUNDING_SOURCE_AND_PAYMENT_METHOD: PermissionByEntityType = {
  AD_ACCOUNT: {
    createRoles: [],
    readRoles: [USER_ROLES.adAccountAdmin, USER_ROLES.adAccountAnalyst, USER_ROLES.buyer],
    updateRoles: [],
    deleteRoles: [],
  },
  CREATIVE_LIBRARY: INITIAL_PERMISSIONS_ROLES,
  MARKETER_ORGANIZATION: {
    createRoles: [USER_ROLES.orgAdmin],
    readRoles: [USER_ROLES.orgAdmin, USER_ROLES.seller],
    updateRoles: [USER_ROLES.orgAdmin],
    deleteRoles: [USER_ROLES.orgAdmin],
  },
  PUBLISHER_ORGANIZATION: {
    createRoles: [],
    readRoles: [USER_ROLES.supportAdmin, USER_ROLES.planner, USER_ROLES.trafficker, USER_ROLES.analyst],
    updateRoles: [],
    deleteRoles: [],
  },
};
